<template>
  <div>
    <i class="fa pull-right clickable"
       :class="{ 'fa-close' : showfilter  , 'fa-filter' : ! showfilter  } "
       @click="$emit('update:showfilter', !showfilter) "></i>
  </div>
</template>

<script>
  export default {
    name: "FilterButton",
    props: ['showfilter']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/FilterButton.vue